
export class BacklogApiErrorDetail {
	public readonly message: string;
	public readonly code: number;
	public readonly moreInfo: string;

	constructor(options: {
		message: string;
		code: number;
		moreInfo: string;
	}) {
		this.message = options.message;
		this.code = options.code;
		this.moreInfo = options.moreInfo;
	}

	toString(): string {
		return `${this.code}:${this.message}:${this.moreInfo}`;
	}
}
